<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <a-input-search
        v-model:value="keyword"
        enter-button
        class="w300"
        placeholder="请输入材料名称关键字"
        @search="search"
      ></a-input-search>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>
    <table-wrapper
      :data-config="{ format: dataFormat }"
      :loading="loading"
      :row-key="'materialId'"
      size="small"
      ref="tableRef"
      :bordered="true"
      :data-source="data"
      :columns="columns"
      :pagination="pagination"
      @onSelectionChange="onSelectionChange"
      @onTableChange="onTableChange"
      :tableHeight="tableHeight"
    ></table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, PropType } from "vue";
import { ReceiveService } from "@/views/purchase/receive/receive.service";
import { MaterialPageReq, MaterialRecord } from "@/views/purchase/receive/receive.interface";
import { columns } from "./constant";
import { arrayUniqByMore } from "@/utils";

export default defineComponent({
  name: "MaterialTable",
  props: {
    orderId: { type: String, default: "" },
    tableHeight:{
      type:Number,
      default:0
    },
    value: { type: Array as PropType<MaterialRecord[]>, default: [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: MaterialRecord[];
      selectedList: any[];
      columns: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns,
    });

    const queryReq = new MaterialPageReq(props.orderId);
    const queryRef = reactive(queryReq);

    const { data, loading, run, pagination } = ReceiveService.useOrderMaterialSelect();

    const search = async () => {
      queryRef.current = 1;
      queryRef.materialName = state.keyword;
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onSelectionChange = ({ids, selectedRows}) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };

    const add = () => {
      const newValue = arrayUniqByMore([...props.value, ...state.selectedRows], ["materialId","systemName"]); 
      emit("update:value", newValue);
    };

    onMounted(async () => {
      await run(queryReq);
    });
    const dataFormat = (rows) => {
      let ids = rows.reduce((pre, cur) => {
        pre.push(cur.id);
        return pre;
      }, []);
      return {
        ids,
        selectedRows: rows,
      };
    };
    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.materialId);
        state.selectedIds = ids;
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      loading,
      data,
      pagination,
      search,
      onTableChange,
      onSelectionChange,
      add,
      dataFormat,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
